import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/app/node_modules/@interness/web-core/src/templates/mdx/default.js";
import CallToAction from '@interness/web-core/src/components/modules/CallToAction/CallToAction';
import HeaderImg from '../../components/HeaderImg';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const HeaderImage = makeShortcode("HeaderImage");
const Wrapper = makeShortcode("Wrapper");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <HeaderImage mdxType="HeaderImage">
    <HeaderImg id="rueckenbeschwerden" mdxType="HeaderImg" />
    </HeaderImage>
    <hr></hr>
    <Wrapper mdxType="Wrapper">
      <h1>{`Rückenbeschwerden`}</h1>
      <h3 {...{
        "id": "ruckenbeschwerden"
      }}>{`Rückenbeschwerden`}</h3>
      <p>{`Die Ursachen können sehr vielfältig sein: Verschleißerkrankungen, Fehlbelastung, Überlastung, Verletzung, rheumatische Stoffwechsellage, vegetative Anspannung…`}</p>
      <p>{`Bei der Behandlung von Wirbelsäulen-Erkrankungen kommen in unserer Praxis folgende Therapien individuell zur Anwendung:`}</p>
      <ul>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/therapien/chiropraktik"
          }}>{`Chiropraktik`}</a>{`: durch gezielte Handgriffe werden Blockierungen an der Wirbelsäule erkannt und durch Reponieren, Mobilisieren oder vorsichtiges Dehnen behandelt`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/therapien/schroepfmassage"
          }}>{`Schröpfmassage`}</a>{`: durch Anregung des Blutflusses wird die Versorgung mit Nährstoffen/Sauerstoff und die Entsorgung der Schlacken-/Schmerzstoffe verbessert`}</li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/therapien/neuraltherapie"
          }}>{`Neuraltherapie`}</a>{`: zur Linderung der Schmerzen werden je nach Erkrankung Procain, Ameisensäure, homöopathische Umstimmungsmittel oder Aufbaupräparate injiziert`}</li>
      </ul>
      <hr></hr>
      <div style={{
        textAlign: 'center'
      }}>
    <CallToAction mdxType="CallToAction" />
      </div>
      <hr></hr>
    </Wrapper>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      